import { createGlobalStyle } from "styled-components";
// import caslon from '../fonts/Caslon540.woff';
import adam from "../fonts/adam.woff";
import normal from "../fonts/FuturaStdLight.woff2";
import normalItalic from "../fonts/FuturaStdLightOblique.woff2";
import bold from "../fonts/FuturaStdMedium.woff2";
import boldItalic from "../fonts/FuturaStdMediumOblique.woff2";

const Typography = createGlobalStyle`
  @font-face {
    font-family: Futura;
    src: url(${normal}) format("woff2");
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: Futura;
    src: url(${normalItalic}) format("woff2");
    font-weight: normal;
    font-style: italic;
  }
  @font-face {
    font-family: Futura;
    src: url(${bold}) format("woff2");
    font-weight: bold;
    font-style: normal;
  }
  @font-face {
    font-family: Futura;
    src: url(${boldItalic}) format("woff2");
    font-weight: bold;
    font-style: italic;
  }

  @font-face {
    font-family: 'Adam';
    src: url(${adam});
    font-style: normal;
  }
  
  html {
    font-family: Futura, sans-serif;
    letter-spacing: 1px;
  }
`;

export default Typography;
